import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import { Button, LoaderMi, Row, Col, ButtonLink } from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RatelierArmeImpression from './components/RatelierArmeImpression';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_DEMANDER_IMPRESSION_ARMES,
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    API_REMONTER_ARMES_IMPRESSION,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_DEMANDER_IMPRESSION_ARMES,
    CONTEXT_REMONTER_ARMES_IMPRESSION,
} from '../../../../constants/apiUrls.constants';
import { getDownloadableFile, MIME_APPLICATION_PDF } from '../../../../utils/fileFunction';
import InformationAdresse from '../../../../components/adresse/InformationsAdresse';
import RoutesArmes from '../../ratelier/armes/routes';
import InformationsPersonnellesImpressionRatelier from './components/InformationsPersonnellesImpressionRatelier';
import { getPath } from '../../../../utils/router';

const DemanderImpression = ({
    getApi,
    postApi,
    reinitialiseApi,
    isLoadingInformationUtilisateur,
    dataInformationUtilisateur,
    dataListeArme,
    isLoadingListeArme,
    dataDemanderImpression,
    isLoadingDemanderImpression,
}) => {
    const [armesSelectionnees, setArmesSelectionnees] = useState();

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_REMONTER_ARMES_IMPRESSION,
            CONTEXT_REMONTER_ARMES_IMPRESSION,
        );

        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );

        return () => {
            reinitialiseApi(CONTEXT_REMONTER_ARMES_IMPRESSION);
            reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
            reinitialiseApi(CONTEXT_DEMANDER_IMPRESSION_ARMES);
        };
    }, []);

    useEffect(() => {
        if (dataDemanderImpression) {
            getDownloadableFile(dataDemanderImpression, "ratelier d'armes", MIME_APPLICATION_PDF);
        }
    }, [dataDemanderImpression]);

    const demanderImpression = () => {
        const dataImpression = {
            listeArmesUuid: armesSelectionnees.map((arme) => arme.uniquid),
        };

        postApi(
            usagerClientReducer,
            API_DEMANDER_IMPRESSION_ARMES,
            dataImpression,
            CONTEXT_DEMANDER_IMPRESSION_ARMES,
        );
    };

    return (
        <div style={{ position: 'relative' }}>
            {(isLoadingInformationUtilisateur ||
                isLoadingListeArme ||
                isLoadingDemanderImpression) && <LoaderMi taille="lg" />}
            <h1>Imprimer mon râtelier</h1>
            <div>
                <h2> Récapitulatif des informations personnelles</h2>
                <Row gutters>
                    <Col lg={6}>
                        <div className="bordure">
                            <InformationsPersonnellesImpressionRatelier
                                informationsPersonnelles={
                                    dataInformationUtilisateur
                                        ? dataInformationUtilisateur.personnePhysique
                                        : null
                                }
                                titre="Identité"
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="bordure">
                            <InformationAdresse
                                adresse={
                                    dataInformationUtilisateur
                                        ? dataInformationUtilisateur.personnePhysique
                                              .adressePrincipale
                                        : null
                                }
                                titre="Adresse de la résidence principale"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                <h2>Liste des armes</h2>
                <p className="gras">
                    {' '}
                    Veuillez sélectionner les armes qui doivent apparaître sur votre impression
                </p>
                <p>
                    Pour désélectionner une arme décochez la case en début de la ligne correspondant
                    à l&apos;arme
                </p>
                <RatelierArmeImpression
                    isLoading={isLoadingListeArme}
                    data={dataListeArme}
                    setArmesSelectionnees={setArmesSelectionnees}
                />
            </div>

            <Row>
                <div className="fr-col-12 btn-group-align-right">
                    <ButtonLink
                        as={Link}
                        to={getPath(RoutesArmes)}
                        variant="secondary"
                        aria-label="Retour à mon râtelier"
                    >
                        Retour
                    </ButtonLink>
                    <Button
                        variant="primary"
                        disabled={!armesSelectionnees || armesSelectionnees.length === 0}
                        onClick={demanderImpression}
                        isLoading={isLoadingDemanderImpression}
                    >
                        Imprimer
                    </Button>
                </div>
            </Row>
        </div>
    );
};

DemanderImpression.propTypes = {
    getApi: PropTypes.func.isRequired,
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    // informations persos
    isLoadingInformationUtilisateur: PropTypes.bool,
    dataInformationUtilisateur: PropTypes.PropTypes.shape({
        personnePhysique: PropTypes.shape({
            nom: PropTypes.string.isRequired,
            nomUsage: PropTypes.string.isRequired,
            prenomUsuel: PropTypes.string.isRequired,
            prenomUn: PropTypes.string.isRequired,
            sexe: PropTypes.string,
            dateNaissance: PropTypes.string,
            lieuNaissance: PropTypes.string,
            codePostalNaissance: PropTypes.string,
            paysNaissance: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            nationalite: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
            adressePrincipale: PropTypes.shape({
                numeroVoie: PropTypes.string,
                extension: PropTypes.string,
                libelleVoie: PropTypes.string,
                lieuDit: PropTypes.string,
                codePostal: PropTypes.string,
                ville: PropTypes.string,
            }).isRequired,
        }).isRequired,
    }),
    // ratelier
    dataListeArme: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
    isLoadingListeArme: PropTypes.bool,
    // impression
    dataDemanderImpression: PropTypes.object,
    isLoadingDemanderImpression: PropTypes.bool,
};

export default connect(
    (state) => {
        const { isLoading: isLoadingInformationUtilisateur, data: dataInformationUtilisateur } =
            state.monCompte.recupererInformationsPersonnelles;
        const { isLoading: isLoadingListeArme, data: dataListeArme } =
            state.armes.impressionRatelier.remonterArmes;
        const { isLoading: isLoadingDemanderImpression, data: dataDemanderImpression } =
            state.armes.impressionRatelier.demanderImpression;
        return {
            isLoadingInformationUtilisateur,
            dataInformationUtilisateur,
            isLoadingListeArme,
            dataListeArme,
            isLoadingDemanderImpression,
            dataDemanderImpression,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(DemanderImpression);
